import { create } from 'zustand';

interface CreditsState {
  credits: number;
  monthly: number;
  maxCredits: number;
  used: number;
  subscription: string;
  isLoading: boolean;
  hasFetched: boolean;
  error: string | null;
  setCredits: (credits: number, monthly: number, used: number, subscription?: string, maxCredits?: number) => void;
  decrementCredits: (amount?: number) => void;
  setLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

export const useCreditsStore = create<CreditsState>((set) => ({
  credits: 0,
  monthly: 5,
  maxCredits: 10,
  used: 0,
  subscription: 'free',
  isLoading: false,
  hasFetched: false,
  error: null,
  setCredits: (credits, monthly, used, subscription, maxCredits) =>
    set((state) => ({
      credits,
      monthly,
      used,
      subscription: subscription ?? state.subscription,
      maxCredits: maxCredits ?? state.maxCredits,
      hasFetched: true,
      error: null,
    })),
  decrementCredits: (amount = 1) =>
    set((state) => ({
      credits: Math.max(0, state.credits - amount),
      used: state.used + amount,
    })),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error, isLoading: false }),
  reset: () =>
    set({
      credits: 0,
      monthly: 5,
      maxCredits: 10,
      used: 0,
      subscription: 'free',
      isLoading: false,
      hasFetched: false,
      error: null,
    }),
}));
